"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumDeepLinkName = void 0;
/**
 * The unique analytics name of the deep link. This is used as part of the event name for deep link events.
 */
exports.EnumDeepLinkName = {
    CaseMemberId: 'CaseMemberID',
};
//# sourceMappingURL=enum-deep-link-name.js.map